import React from "react";
import { Link } from "react-router-dom";
import Container from "../common/Container";

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <Container>
        <div className="py-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-bold text-white">
              Brightly<span className="text-blue-500">LLC</span>
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Brightly LLC is a software development company delivering scalable,
              secure, and high-performance digital solutions for modern
              businesses.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">
              Services
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>Web Development</li>
              <li>Mobile Applications</li>
              <li>UI/UX Design</li>
              <li>AI & Automation</li>
              <li>Cloud & DevOps</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">
              Company
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/about" className="hover:text-white">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">
              Get in touch
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li>Email: <a href="mailto:support@thebrightlyllc.com">support@thebrightlyllc.com</a></li>
              <li>Tel: <a href="tel:+18333888796">+1 833-388-8796</a></li>
              <li>Address: 12740 Parnell Ave Baton Rouge, LA 70815</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 py-6 text-sm flex flex-col sm:flex-row items-center justify-between gap-4">
          <span>
            © {new Date().getFullYear()} Brightly LLC. All rights reserved.
          </span>

          <div className="flex gap-6">
            <span className="hover:text-white cursor-pointer">
              Privacy Policy
            </span>
            <span className="hover:text-white cursor-pointer">
              Terms of Service
            </span>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
